









































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
@Component
export default class BasicSignupForm extends Vue {
  @Prop({ default: {} }) formValues;
  @Prop() errors;
  private candidatePhone = '';
  private showPassword = false;
  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }
  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  setShowPassword() {
    this.showPassword = !this.showPassword;
  }

  updateCandidatePhone(event) {
    this.formValues.phone =
      '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.formValues.phoneNumberValid = event.isValid;
  }

  confirmPasswordUpdate(e) {
    this.$emit('confirm-password-change', e.target.value);
  }

  get passwordCondition() {
    return vxm.utility.passwordConditions;
  }
}
